import { render, staticRenderFns } from "./comp_ProductPage-Description.vue?vue&type=template&id=53d1db36&scoped=true&"
import script from "./comp_ProductPage-Description.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPage-Description.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductPage-Description.vue?vue&type=style&index=0&id=53d1db36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d1db36",
  null
  
)

export default component.exports